import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c70384de&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c70384de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70384de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c70384de')) {
      api.createRecord('c70384de', component.options)
    } else {
      api.reload('c70384de', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c70384de&scoped=true&", function () {
      api.rerender('c70384de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BQYjMwGoUhB9/JS/comp/SearchFilterTokens.vue"
export default component.exports